<style>
.resources-page-template .avatar-icon > i {
  color: #fff;
}
</style>
<template>
  <!-- <app-layout class="resources-page-template"> -->
  <div class="resources-page-template">
    <Row type="flex" justify="center" v-if="menuItems">
      <i-col :span="24" v-show="(!sortedMenu || sortedMenu.length <= 0) && !isMenuItemLoading">
        <p align="center" style="color:#ddd">Empty menu items.</p>
      </i-col>
      <i-col :span="24" v-for="(item, i) in sortedMenu" :key="i">
        <div
          style="cursor: pointer"
          :bordered="false"
          :style="{
            borderRadius: '0',
            borderTop: '0px solid #F2F2F2',
            padding: '10px 0'
          }"
          :padding="0"
        >
          <div @click="onSelectMenu(item)" v-if="!isLink(item)">
            <Avatar
              shape="square"
              :src="postPreviewImage(item)"
              style="background:transparent;vertical-align:middle;"
            ></Avatar>
            &nbsp; {{ item.title }}
          </div>
          <a style="color: #657180" :href="link(item)" :target="link(item) != '#' ? '_blank' : '_self'" v-else>
            <Avatar
              shape="square"
              :src="postPreviewImage(item)"
              style="background:transparent;vertical-align:middle;"
            ></Avatar>
            &nbsp; {{ item.title }}
          </a>
        </div>
      </i-col>
    </Row>
    <div
      v-if="isMenuItemLoading"
      style="display: flex; justify-content: center; padding-right: 15px"
    >
      <Icon type="load-c" size="18" class="spinner-load" style="margin-right: 10px"></Icon>
    </div>

    <Modal
      v-model="genericId.show"
      :title="`Enter a valid ${genericIdLabel} to proceed`"
      :scrollable="true"
      :transfer="true"
      :mask-closable="false"
    >
      <div>
        <Input
          size="large"
          :disabled="genericId.isLoading"
          v-model="genericId.id"
          :placeholder="`Enter your ${genericIdLabel}`"
        />
      </div>
      <div slot="footer">
        <Button
          type="primary"
          :disabled="genericId.isLoading || !genericId.id"
          :loading="genericId.isLoading"
          @click="saveGenericId"
        >Save</Button>
      </div>
    </Modal>

    <Modal
      v-model="showInvite"
      class="shareModal"
      title="Invite others to join"
      :closable="false"
      :scrollable="true"
      :transfer="true"
      :mask-closable="false"
      @on-visible-change="onInviteVisibleChange"
    >
      <div
        slot="header"
        class="flex-container direction-row center"
        style="justify-content:space-between;"
      >
        <div class="order-1"></div>
        <b class="order-2">Invite others to join</b>
        <div class="order-3"></div>
        <img
          alt=" "
          @click="showInvite = false"
          style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
          src="@/assets/close.png"
        />
      </div>
      <div v-if="showInvite" style="height:100%;overflow:visible;overflow-y:visible">
        <share-component ref="shareComponent"></share-component>
      </div>
      <div slot="footer">
        <Button type="text" @click="showInvite = false">Close</Button>
      </div>
    </Modal>
    <ModalHolder :title="'REPORT'" m-top="0" m-height="15vh" :is-show="showReportWarning">
      <template slot="mheader">
        <p>Report</p>
      </template>
      <template slot="mcontent">
        <p>
          <!-- For any matters that need immediate response, may it be a problem
            in your community or any fraud related activities, you can send your
          concerns here.-->
        </p>
      </template>
      <template slot="mfooter">
        <Button type="text" @click="showReportWarning = false">Cancel</Button>
        <Button type="primary" v-on:click="routeToReport">Continue</Button>
      </template>
    </ModalHolder>
    <ReportModalComponent :type="reportType" v-if="reportType" @closeModal="reportType = null"></ReportModalComponent>
  </div>
</template>

<script>
// import PostUpdateModalComponent from '@/components/PostUpdateModalComponent'
import ReportModalComponent from "@/components/ReportModalComponent";
// import PostUpdateComponent from '@/views/PostUpdateComponent'
import ShareComponent from "@/views/ShareComponent";
import ModalHolder from "@/components/ModalHolderComponent";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import $ from "jquery";
import { Message } from "iview";
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "ResourcesComponent",
  data() {
    return {
      genericId: {
        show: false,
        isLoading: false,
        id: "",
        action: () => {}
      },
      showReportWarning: false,
      reportType: null,
      postDocument: {
        title: "Post Document",
        type: "add_ons",
        thumbnail_photo: [
          {
            medium: require("@/assets/docs.png")
          }
        ],
        order: 4,
        data: {
          add_on_slug: "post_document"
        }
      }
    };
  },
  components: {
    // PostUpdateModalComponent,
    ModalHolder,
    ShareComponent,
    // PostUpdateComponent,
    ReportModalComponent
  },
  computed: {
    ...mapGetters("user", ["isBroadcast", "userInfo", "brandInfo"]),
    genericIdLabel() {
      return _.get(this.brandInfo, "generic_id.label", "ID");
    },
    isGuest() {
      return navigator.onLine && this.profileInfo.user_type === "guest";
    },
    sortedMenu() {
      return _.orderBy(this.menuItems.pages, "order");
    },
    menuItems() {
      let selections = this.$store.state.menuItems;

      if (this.isBroadcast) {
        selections.pages.forEach((element, x) => {
          if (
            element.type === "add_ons" &&
            element.data.add_on_slug == "post_update"
          )
            selections.pages.splice(x, 1);
        });
      }

      return selections;
    },
    isMenuItemLoading() {
      return this.$store.state.isMenuItemLoading;
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    ifMobile: {
      get() {
        return (
          Utils.checkMobileOS() == "iOS" || Utils.checkMobileOS() == "Android"
        );
      }
    },
    bullhorn: {
      get() {
        return require("@/assets/bullhorn.png");
      }
    },
    showSuccess: {
      get() {
        return this.$store.state.share.showSuccess;
      }
    },
    showInvite: {
      get() {
        return this.$store.state.share.showInvite;
      },
      set(v) {
        if (navigator.onLine) this.$store.commit("share/setShowInvite", v);
        else {
          this.$store.commit("share/setShowInvite", false);
          this.$store.commit("hitOffline");
        }
      }
    }
  },
  methods: {
    link(v) {
       switch (v.data.attachment_type) {
        case "link":
            let url = v.data.url;
            if (v.data.url.includes("{userId}")) {
              url = url.replace(/{userId}/g, this.userInfo.id);
            }

            if (this.brandInfo.generic_id) {
              if (
                this.brandInfo.generic_id.slug &&
                v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)
              )
                if (this.userInfo.generic_id) {
                  let rgx = `{${this.brandInfo.generic_id.slug}}`;
                  url = url.replace(rgx, this.userInfo.generic_id);
                } else
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
            } else {
              if (
                v.data.url.includes("{generic_id}") ||
                v.data.url.includes("{genericId}")
              ) {
                if (this.userInfo.generic_id) {
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
                }
              }
            }

            if (v.data.url.includes("{studentId}")) {
              if (this.userInfo.generic_id) {
                url = url.replace(/{studentId}/g, this.userInfo.generic_id);
              }
            }
            if (v.data.url.includes("{appName}")) {
              url = url.replace(/{appName}/g, this.brandInfo.title);
            }
            if (v.data.url.includes("{generic_email}")) {
              url = url.replace(/{generic_email}/g, this.userInfo.generic_email);
            }
            if (v.data.url.includes("{generic_mobile_number}")) {
              url = url.replace(/{generic_mobile_number}/g, this.userInfo.generic_mobile_number);
            }
            return url
          break;
      }
    },
    customUrlAction(v) {
      switch (v.data.attachment_type) {
        case "link":
            let url = v.data.url;
            if (v.data.url.includes("{userId}")) {
              url = url.replace(/{userId}/g, this.userInfo.id);
            }

            if (this.brandInfo.generic_id) {
              if (
                this.brandInfo.generic_id.slug &&
                v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)
              )
                if (this.userInfo.generic_id) {
                  let rgx = `{${this.brandInfo.generic_id.slug}}`;
                  url = url.replace(rgx, this.userInfo.generic_id);
                } else
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
            } else {
              if (
                v.data.url.includes("{generic_id}") ||
                v.data.url.includes("{genericId}")
              ) {
                if (this.userInfo.generic_id) {
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
                }
              }
            }

            if (v.data.url.includes("{studentId}")) {
              if (this.userInfo.generic_id) {
                url = url.replace(/{studentId}/g, this.userInfo.generic_id);
              }
            }
            if (v.data.url.includes("{appName}")) {
              url = url.replace(/{appName}/g, this.brandInfo.title);
            }
            if (v.data.url.includes("{generic_email}")) {
              url = url.replace(/{generic_email}/g, this.userInfo.generic_email);
            }
            if (v.data.url.includes("{generic_mobile_number}")) {
              url = url.replace(/{generic_mobile_number}/g, this.userInfo.generic_mobile_number);
            }
            window.open(url);
            return false;
          break;
      }
    },
    async saveGenericId() {
      this.genericId.isLoading = true;

      try {
        await this.$store.dispatch("user/updateUserInfo", {
          id: this.userInfo.id,
          data: {
            generic_id: this.genericId.id
          }
        });
        this.genericId.action();
      } catch (e) {
        Message.error(`Unable to save ${genericIdLabel}`);
      } finally {
        this.genericId.show = false;
        this.genericId.id = "";
        this.genericId.isLoading = false;
        this.genericId.action = () => {};
      }
    },
    isLink(item) {
      let hasGenericId = this.userInfo.generic_id;
      let hasGenericIdUrl = false;
      let isLinkType =
        item.type == "attachment" && item.data.attachment_type == "link";

      if (isLinkType)
        hasGenericIdUrl = item.data.url.includes("{" + this.brandInfo.generic_id.slug + "}")

      if (isLinkType && !hasGenericIdUrl) return true;
      else if (isLinkType && hasGenericIdUrl && !hasGenericId) return false;
      else return isLinkType;
    },
    onSelectMenu(i) {
      console.log("onSelectMenu...", i);
      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: i.id , link_tag: `Do Action Menu: ${i.title}`});
      if (
        i.data &&
        i.type === "group_page" &&
        "careplan_id" in i.data &&
        i.data.careplan_id
      ) {
        console.log("push to resources", i.data.careplan_id);
        this.$router.push("/resources/" + i.data.careplan_id);
        return false;
      }

      console.log("event emitted...", i);

      if (this.isLink(i))
        return false
      else
        BroadcastEvent.$emit("ADDONMENU", i);
      // if( i.data && 'menu_slug' in i.data && i.data.menu_slug ) {
      //   switch(i.data.menu_slug) {
      //     case 'post':
      //       this.openPostSelection()
      //       break;
      //     case 'hero':
      //       this.showReportModal('hero')
      //       break;
      //     case 'concern':
      //       console.log('onSelectMenu re-routing...');
      //       // this.reRouteUrl(Cons[0].GROUP_ID.report_concern, 'concern')
      //       this.showReportModal('concern')
      //       break;
      //     case 'invite':
      //       this.showInvite = true;
      //       break;
      //     case 'donate':
      //       this.$router.push('/donate?rid=' + Cons[0].GROUP_ID.donate )
      //       break;
      //     case 'suggestion':
      //       // this.showReportModal('suggestion')
      //       this.showReportModal('story')
      //       break;
      //   }
      // }
    },
    postPreviewImage(act) {
      return Utils.getDisplayImage("activity", act, "medium");
    },
    sendMail() {
      $("#sendViaMail")[0].click();
    },
    sendSMS() {
      $("#sendViaSMS")[0].click();
    },
    onShare() {
      if (this.profileInfo.user_type === "guest") {
        this.$store.commit("hitCheckpoint");
        return false;
      }
      this.showInvite = true;
    },
    openPostSelection() {
      console.log(navigator.onLine);
      if (navigator.onLine) {
        if (this.profileInfo.user_type === "guest") {
          this.$store.commit("hitCheckpoint");
          return false;
        }

        // this.$store.dispatch('menu/getPermittedPlan', null).then((res) => {
        //   if(res.data.length > 0){
        //     this.$store.commit('menu/setPostSelectionModal', true)
        //   }else{
        //     this.onProceed('journal')
        //   }
        // });

        this.$store.commit("menu/setPostSelectionModal", true);
      } else {
        this.$store.commit("hitOffline");
      }
    },
    openPostDocument() {
      if (navigator.onLine) {
        if (this.profileInfo.user_type === "guest") {
          this.$store.commit("hitCheckpoint");
          return false;
        }

        this.$store.commit("menu/setPostDocumentModal", true);

        // this.$store.dispatch('menu/getPermittedPlan', null).then((res) => {
        //   if(res.data.length > 0){
        //     this.$store.commit('menu/setPostSelectionModal', true)
        //   }else{
        //     this.onProceed('journal')
        //   }
        // });
      } else {
        this.$store.commit("hitOffline");
      }
    },
    onProceed(data) {
      if (data != "journal_public" && data != "journal_private") {
        let careplanId = data.id;
        this.$store.commit("menu/setPostSelectionModal", false);
        this.$router.push({
          query: {
            post: careplanId,
            action: "post"
          }
        });

        this.$store.commit("publicModule/setShowPostItemModal", true);
      } else {
        if (data == "journal_public") {
          this.$store.commit("menu/setPostSelectionModal", false);
          this.$router.push({
            query: {
              post: this.profileInfo.careplan_id,
              action: "post",
              is_public: true,
              tab: "timeline"
            }
          });

          this.$store.commit("publicModule/setShowPostItemModal", true);
        } else {
          this.$store.commit("menu/setPostSelectionModal", false);
          this.$router.push({
            query: {
              post: this.profileInfo.private_careplan_id,
              action: "post",
              is_public: false,
              tab: "team"
            }
          });

          this.$store.commit("publicModule/setShowPostItemModal", true);
        }
      }
    },
    reRouteUrl(id, type) {
      if (navigator.onLine) {
        this.$router.push({ query: { post: id, type: type } });
        this.$store.commit("menu/setPostSelectionModal", false);
        this.$store
          .dispatch("feed/getCareplanInfo", this.$route.query.post)
          .then(res => {
            console.log("DoActionMenuB reRouteUrl...", res);
            this.$store.commit("publicModule/setShowPostItemModal", true);
          });
      } else {
        this.$store.commit("hitOffline");
      }
    },
    routeToReport() {
      this.showReportWarning = false;
      this.$router.push({
        path: "/post-update/" + Cons[0].GROUP_ID.report_concern
      });
    },
    onInviteVisibleChange(isVisible) {
      if (isVisible) {
        if (this.showSuccess) {
          this.$store.commit("share/setShowSuccess", false);
        }
      } else {
        this.$refs.shareComponent.resetFields();
      }
    },
    showReportModal(type) {
      if (navigator.onLine) {
        this.reportType = type;
        this.$store.commit("menu/setShowWizardModalComponent", true);
      } else {
        this.$store.commit("hitOffline");
      }
    },
    showInviteModal() {
      this.$store.commit("user/showInviteModal", { showInvite: true });
    },
    eventEmitter: function() {
      BroadcastEvent.$on("ONSHOWREPORTMODAL", type => {
        switch (type) {
          case "post":
            this.openPostSelection();
            break;
          case "hero":
            this.showReportModal("hero");
            break;
          case "concern":
            this.showReportModal("concern");
            break;
          case "invite":
            // this.showInvite = true;
            this.showInviteModal();
            break;
          case "donate":
            this.$router.push("/donate?rid=" + Cons[0].GROUP_ID.donate);
            break;
          case "suggestion":
            // this.showReportModal('suggestion')
            this.showReportModal("story");
            break;
          case "story":
            // this.showReportModal('suggestion')
            this.showReportModal("story");
            break;
        }
      });
    }
  },
  mounted() {
    this.eventEmitter();
  },
  created() {
    this.genericId.id = this.userInfo.generic_id;

    BroadcastEvent.$on("ADDONMENU", v => {
      console.log(v);
      let item = v;
      if (item.type == "sub_menu") {
        this.$router.push({
          path: "/submenu/" + item.data.group_id,
          meta: { title: item.title }
        });
        return false;
      }

      if (item.type == "group_page") {
        this.$router.push({
          path: "/resources/" + item.data.careplan_id + "?tab=posts"
        });
        return false;
      }

      if (item.type == "group_page_type") {
        let t = item.data.group_type;

        if (t == "organization") t = "alliance";

        this.$router.push({ path: "/group-type/" + t });
        return false;
      }

      if (v.type === "attachment" && v.data && "attachment_type" in v.data) {
        if (v.data.attachment_type == "link") {
          if (_.get(this.brandInfo, "generic_id.slug", false)) {
            if (
              v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`) &&
              !this.userInfo.generic_id
            ) {
              this.genericId.show = true;
              this.genericId.action = () => this.customUrlAction(v);
              return false;
            }
          }
        }
        this.customUrlAction(v);
        return false;
      }

      if (
        v.type === "add_ons" &&
        "add_on_slug" in v.data &&
        v.data.add_on_slug
      ) {
        switch (v.data.add_on_slug) {
          case "videos":
            this.$router.push({ path: "/videos" });
            break;
          case "people":
            this.$router.push({ path: "/people-menu" });
            break;
          case "latest":
            this.$router.push({
              path:
                "/people?id=500E3120-B0F8-29C3-5D76-E43F66098341&type=people&section=Latest"
            });
            break;
          case "nearby":
            this.$router.push({ path: "/nearby" });
            break;
          case "post_update":
            this.openPostSelection();
            break;
          case "donate":
            this.$router.push("/donate?rid=" + Cons[0].GROUP_ID.donate);
            break;
          case "concern":
            if (this.isGuest) this.$store.commit("hitCheckpoint");
            else this.showReportModal("concern");
            break;
          case "story":
            if (this.isGuest) this.$store.commit("hitCheckpoint");
            else this.showReportModal("story");
            break;
          case "hero":
            if (this.isGuest) this.$store.commit("hitCheckpoint");
            else this.showReportModal("hero");
            break;
          case "invite":
            // this.showInvite = true;
            this.showInviteModal();
            break;
          case "post_document":
            this.openPostDocument();
            break;
          case "call_to_action":
            this.$router.push({ path: "/calltoaction" });
            break;
          case "messaging":
            this.$router.push({ path: "/messages" });
            break;
        }
        return false;
      }

      if (item.type != "hybrid")
        this.$router.push({ path: "/feed/" + item.id });
      else {
        if (this.brandInfo.generic_id && item.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)) {
          if (!this.userInfo.generic_id) {
            this.genericId.show = true;
            this.genericId.action = () => this.customUrlAction(v);
            return false;
          }
          else 
            this.$router.push({ path: "/extras/" + item.id });
        }
        else
          this.$router.push({ path: "/extras/" + item.id });
      }
    });
  }
};
</script>
